module.exports = __webpack_public_path__ + "media/images/plus-1b353b20ce59471f6896dc15e6673b06.svg";